module.exports = __webpack_public_path__ + "img/image-placeholder.d6eeafd5.gif";